module.exports = __webpack_public_path__ + "img/audio-permission-setting-safari.a60fae8a.gif";